export default __webpack_public_path__ + "static/media/nano.4b97d523.pdf";